/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HandIcon = /*#__PURE__*/ createSvgIcon(
  'HandIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.319.565a1.7 1.7 0 012.372 1.34A1.7 1.7 0 0114.1 3.45v3.198a2.026 2.026 0 01.977-.4 1.378 1.378 0 01.106-.008c.126-.006.446-.01.747.169.355.21.57.6.57 1.151v4.09c0 .015 0 .03-.002.044a5.59 5.59 0 01-1.592 3.441.497.497 0 01-.08.124 5.39 5.39 0 00-1.326 3.724.5.5 0 01-.5.517H5.43a.5.5 0 01-.5-.5v-1.968A5.02 5.02 0 013.5 13.92V5.5a1.705 1.705 0 012.41-1.552V3.45a1.7 1.7 0 012.409-1.545 1.7 1.7 0 011-1.34zM8.31 3.45a.7.7 0 00-1.4 0V5.5a.5.5 0 11-1 0 .705.705 0 00-1.41 0v8.396a4.02 4.02 0 001.27 2.557.5.5 0 01.16.367v1.68h6.574a6.39 6.39 0 011.419-3.72.498.498 0 01.136-.216 4.59 4.59 0 001.441-2.936V7.56a.553.553 0 00-.042-.248.094.094 0 00-.038-.043.38.38 0 00-.195-.03m-.017.001l-.022.002a1.027 1.027 0 00-.481.202c-.25.192-.605.644-.605 1.756a.5.5 0 01-1 0V3.45a.7.7 0 10-1.4 0h-1V2.23c0-.015 0-.03.002-.046a.7.7 0 10-1.394 0l-.498.046h.5v1.22a.5.5 0 11-1 0"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default HandIcon;
